export default __webpack_public_path__ + "static/media/amount-icon.cc8b9c7a.svg";